import {
  Box,
  Center,
  Icon,
  Image,
  ImageProps,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react'
import { Image as ImageIcon } from 'lucide-react'

const sizeOptions = {
  xs: 20,
  sm: 36,
  md: 48,
  lg: 72,
}

export function ImageContainer({
  src,
  size = 'md',
  ...props
}: ImageProps & { size?: keyof typeof sizeOptions }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box>
      <Center
        h={sizeOptions[size]}
        w={sizeOptions[size]}
        overflow="hidden"
        cursor={src ? 'pointer' : undefined}
        border="1px solid"
        borderRadius="sm"
        borderColor="gray.200"
        onClick={src ? onOpen : undefined}
      >
        {src ? (
          <Image
            p={2}
            maxW={sizeOptions[size]}
            maxH={sizeOptions[size]}
            src={src}
            {...props}
          />
        ) : (
          <Icon
            as={ImageIcon}
            boxSize={sizeOptions[size] - 4}
            strokeWidth={0.25}
            color="gray.300"
          />
        )}
      </Center>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        blockScrollOnMount={false}
        size="2xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <Center py={4}>
              <Center
                h="70vh"
                w="80vw"
                overflow="hidden"
                border="1px solid"
                borderRadius="sm"
                borderColor="gray.300"
              >
                <Image maxH="70vh" maxW="80vw" p={2} src={src} {...props} />
              </Center>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}
